import WixExperiments from '@wix/wix-experiments';
import {injectable, decorate} from 'inversify';
import {ExperimentNames} from './ExperimentNames';
import {IExperimentManager} from './IExperimentManager';

export class ExperimentManager implements IExperimentManager {
  private readonly experiments: WixExperiments;

  constructor() {
    this.experiments = new WixExperiments({experiments: window.__EXPERIMENTS__});
  }

  isEnabled(key: ExperimentNames): boolean {
    return this.experiments.enabled(key);
  }
}

decorate(injectable(), ExperimentManager);
